import { Injectable } from '@angular/core';
import {environment} from '../../../environments/environment';
import {Observable} from 'rxjs';
import {HttpClient} from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class DesignationService {

  constructor(private http: HttpClient) { }

  getDesignations(): Observable<any> {
    const url = `${environment.apiOrigin}/api/organizations/designations`;
    return this.http.get(url);
  }
  getDesignation(id: string): Observable<any> {
    const url = `${environment.apiOrigin}/api/organizations/designations/${id}`;
    return this.http.get(url);
  }
  deleteDesignation(id: string): Observable<any> {
    const url = `${environment.apiOrigin}/api/organizations/designations/${id}`;
    return this.http.delete(url);
  }

  saveDesignation(value: any): Observable<any> {
    const url = `${environment.apiOrigin}/api/designations`;
    if (value.id) {
      return this.http.post(url, value);
    } else {
      return this.http.put(url, value);
    }
  }
}
